import { render, staticRenderFns } from "./PopupGradeCriteria.vue?vue&type=template&id=379a7244&scoped=true"
import script from "./PopupGradeCriteria.vue?vue&type=script&lang=js"
export * from "./PopupGradeCriteria.vue?vue&type=script&lang=js"
import style0 from "./PopupGradeCriteria.vue?vue&type=style&index=0&id=379a7244&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "379a7244",
  null
  
)

export default component.exports